
import { fetchPrice } from '../services/priceService';
export function getPrice(symbol: string, from: any = null, to: any = null) {
    return (dispatch: any) => {
        dispatch({ type: 'RECEIVE_PRICES', prices: [], loading: true });
        fetchPrice(symbol, from, to).then((response) => {
            dispatch({ type: 'RECEIVE_PRICES', prices: response , loading: false});
        }).catch((err) => {
            console.error('Failed to load report:', err);
            dispatch({ type: 'RECEIVE_PRICES', prices: [], loading: true });
        });
    };
}